module.exports = __webpack_public_path__ + "15b849951f55f2aeb29edd5ad0ed7e15.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_star_white.png
// module id = 65
// module chunks = 0 1 2 3 4